import { useTranslation } from "react-i18next";
import { LandingNavbar } from "@/components/landing/LandingNavbar";
import { LandingFooter } from "@/components/landing/LandingFooter";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";

export default function Privacy() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background">
      <LandingNavbar />
      <main className="pt-24 pb-16 px-4 max-w-3xl mx-auto">
        <Button variant="ghost" size="sm" asChild className="mb-6">
          <Link to="/landing">
            <ArrowLeft className="h-4 w-4 mr-2" />
            {t("common.back")}
          </Link>
        </Button>

        <h1 className="text-3xl font-bold mb-8">{t("legal.privacy.title")}</h1>

        <div className="space-y-6 text-muted-foreground">
          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.privacy.overview")}
            </h2>
            <p>{t("legal.privacy.overviewText")}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.privacy.controller")}
            </h2>
            <p>
              {/* TODO: Echte Firmendaten eintragen */}
              CheckMaty GmbH
              <br />
              Musterstraße 1<br />
              12345 Musterstadt
              <br />
              E-Mail: datenschutz@checkmaty.com
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.privacy.dataCollection")}
            </h2>
            <p>{t("legal.privacy.dataCollectionText")}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.privacy.cookies")}
            </h2>
            <p>{t("legal.privacy.cookiesText")}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.privacy.hosting")}
            </h2>
            <p>{t("legal.privacy.hostingText")}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.privacy.rights")}
            </h2>
            <p>{t("legal.privacy.rightsText")}</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">
              {t("legal.privacy.changes")}
            </h2>
            <p>{t("legal.privacy.changesText")}</p>
          </section>
        </div>
      </main>
      <LandingFooter />
    </div>
  );
}
